<template>
  <section class="video-panel">
    <article class="video-card">
      <div class="video-card__header">
        <span>Minha camera</span>
        <v-icon small color="#6f8063">{{ localVideoActive ? 'mdi-video' : 'mdi-microphone' }}</v-icon>
      </div>

      <div class="video-card__stage">
        <video v-show="localVideoActive" ref="localVideo" autoplay playsinline muted></video>
        <div v-if="!localStream" class="video-card__empty">
          <v-icon color="#9b8c76">mdi-account-circle-outline</v-icon>
          <span>Camera desligada</span>
        </div>
        <div v-else-if="localAudioOnly" class="video-card__empty">
          <v-icon color="#6f8063">mdi-microphone</v-icon>
          <span>Somente audio</span>
        </div>
      </div>
    </article>

    <article class="video-card">
      <div class="video-card__header">
        <span>Camera da parceira</span>
        <v-icon small :color="partnerOnline ? '#6f8063' : '#9b8c76'">
          {{ partnerOnline ? 'mdi-heart-pulse' : 'mdi-heart-outline' }}
        </v-icon>
      </div>

      <div class="video-card__stage">
        <video v-show="remoteVideoActive" ref="remoteVideo" autoplay playsinline></video>
        <div v-if="!remoteStream" class="video-card__empty">
          <v-icon color="#9b8c76">mdi-account-heart-outline</v-icon>
          <span>{{ partnerOnline ? 'Aguardando chamada...' : 'Aguardando parceira entrar...' }}</span>
        </div>
        <div v-else-if="remoteAudioOnly" class="video-card__empty">
          <v-icon color="#6f8063">mdi-microphone</v-icon>
          <span>Somente audio</span>
        </div>
      </div>
    </article>

    <v-alert v-if="cameraError" dense text type="warning" class="video-panel__alert">
      {{ cameraError }}
    </v-alert>
  </section>
</template>

<script>
export default {
  name: 'BibleVideoPanel',
  props: {
    localStream: {
      type: Object,
      default: null,
    },
    remoteStream: {
      type: Object,
      default: null,
    },
    partnerOnline: {
      type: Boolean,
      default: false,
    },
    cameraError: {
      type: String,
      default: '',
    },
  },
  computed: {
    localVideoActive() {
      return !!this.localStream?.getVideoTracks?.().length;
    },
    remoteVideoActive() {
      return !!this.remoteStream?.getVideoTracks?.().length;
    },
    localAudioOnly() {
      return !!this.localStream && !this.localVideoActive;
    },
    remoteAudioOnly() {
      return !!this.remoteStream && !this.remoteVideoActive;
    },
  },
  watch: {
    localStream: {
      handler(stream) {
        this.assignStream('localVideo', stream);
      },
      immediate: true,
    },
    remoteStream: {
      handler(stream) {
        this.assignStream('remoteVideo', stream);
      },
      immediate: true,
    },
  },
  methods: {
    assignStream(refName, stream) {
      this.$nextTick(() => {
        const video = this.$refs[refName];
        if (video && video.srcObject !== stream) {
          video.srcObject = stream || null;
        }
      });
    },
  },
};
</script>

<style scoped>
.video-panel {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.video-card {
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid rgba(97, 112, 89, 0.2);
  background: #fffdf8;
  box-shadow: 0 10px 26px rgba(71, 59, 42, 0.07);
}

.video-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 13px;
  color: #4d4439;
  font-size: 0.9rem;
  font-weight: 700;
  border-bottom: 1px solid rgba(97, 112, 89, 0.12);
}

.video-card__stage {
  position: relative;
  aspect-ratio: 16 / 10;
  background: linear-gradient(135deg, #e8ece8, #faf4e7);
}

.video-card video {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  background: transparent;
}

.video-card__empty {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #7c7163;
  font-size: 0.9rem;
  font-weight: 600;
  text-align: center;
  padding: 16px;
}

.video-card__empty .v-icon {
  font-size: 38px;
}

.video-panel__alert {
  grid-column: 1 / -1;
  margin: 0;
}

@media (max-width: 760px) {
  .video-panel {
    grid-template-columns: 1fr;
  }
}
</style>
